<div class="FormsExperience">
    @if (isSaving || isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <div>
            <div>
                <app-forms-main [notFound]="notFound" [inModal]="inModal" [importData]="importData" [formId]="formId" [formFlow]="formFlow" [flowState]="flowState" (flowStateChange)="onFlowStateChange($event)" [returnUrl]="returnUrl" [viewOnly]="viewOnly" (valuesChange)="onValuesChange($event)" (saveData)="onSaveData($event)" (resetForm)="onResetForm()" (cancelEdit)="onCancelEdit()"></app-forms-main>
            </div>
        </div>
    }
</div>

<ng-template #createExperienceSupplierModal>
    <div class="modal-header d-flex justify-content-end p-2">
        <button type="button" class="modal-close btn btn-link" (click)="createExperienceSupplierDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <app-forms-experience-supplier [elementId]="createModalData.id" [inModal]="true" (formReturn)="onCreateExperienceSupplierModalReturn($event)"></app-forms-experience-supplier>
    </div>
</ng-template>
